<template>
    <b-container>
        <Loading :active.sync="Loading"></Loading>
        <h2>Filtro Of</h2>
        <div  v-if="!isMobile()" >
        <b-col lg="12"  class="my-1">    
            <div class="flex  mt-3 mb-0 ml-5">
  			    <select class="form-control" v-model="selected"  style="width:auto;">
				    <option v-for="campo in campos">{{ campo }}</option>
				</select>
				<input v-if="selected == 'Orden'" type="text" placeholder="Buscar" class="form-control " v-model="valor"  @keyup.enter="buscar">
                <div v-else class="flex contenedor-fechas">
                    <div class="fecha-inicial">
                        <label for="fechain">fecha inicial</label>
                        <Vbdatapicker    v-model="dia" id="fechain" form-control  />
                    </div>
                    <div class="fecha-final">
                        <label for="fechafin">fecha final</label>
                        <Vbdatapicker    v-model="dia2"  id="fechafin" form-control  />
                    </div>
                </div>
                <b-button v-if="sw" class="buscar"  :disabled="!selected" @click="buscar">Buscar</b-button>
                <b-button v-else class="buscar"  :disabled="!selected" @click="limpiar">Limpiar</b-button>
                <b-form-group
                  label="Por página"
                  label-cols-sm="6"
                  label-cols-md="6"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="perPageSelect"
                  class="ml-5"
            >
                <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                ></b-form-select>
            </b-form-group>
			</div>	
            
        </b-col>
        <div v-if="datosphp != false"> 
            <vtable :items="datosphp" :fields="fields"  :currentPage="currentPage" :perPage="perPage" :sortBy="sortBy" :sortDesc="sortDesc" />
            <b-pagination
                    v-model="currentPage"
                    :total-rows="datosphp.length"
                    :per-page="perPage"
                    align="center" 
                    
                    class="my-0"
                    >
            </b-pagination>
        </div>
        <div v-else> NO DATA</div>
        </div>
        <div v-else >
             
            <div class="flex">
  			    <select class="form-control" v-model="selected"  style="width:auto;">
				    <option v-for="campo in campos">{{ campo }}</option>
				</select>
				<input v-if="selected == 'Orden'" type="text" placeholder="Buscar" class="form-control " v-model="valor"  @keyup.enter="buscar">
                <div v-else class="flex contenedor-fechas">
                    <div class="fecha-inicial">
                        <label for="fechain">fecha inicial</label>
                        <Vbdatapicker    v-model="dia" id="fechain" form-control  />
                    </div>
                    <div class="fecha-final">
                        <label for="fechafin">fecha final</label>
                        <Vbdatapicker    v-model="dia2"  id="fechafin" form-control  />
                    </div>
                </div>
                <b-button v-if="sw" class="buscar"  :disabled="!selected" @click="buscar">Buscar</b-button>
                <b-button v-else class="buscar"  :disabled="!selected" @click="limpiar">Limpiar</b-button>
                <b-form-group
                  label="Por página"
                  label-size="sm"
                  label-for="perPageSelect"
                  
            >
                <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                ></b-form-select>
            </b-form-group>
			</div>	
            
       
            <div v-if="datosphp != false">    
                <vtable :items="datosphp" :fields="fields"  :currentPage="currentPage" :perPage="perPage" :sortBy="sortBy" :sortDesc="sortDesc" />
                <b-pagination
                      v-model="currentPage"
                      :total-rows="datosphp.length"
                      :per-page="perPage"
                      align="center" 

                      class="my-0"
                    >
                </b-pagination>
            </div>
            <div v-else> NO DATA</div>
        </div>
    </b-container>   
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    import vtable from '@/components/bitacoras/vtable'
    import moment from 'moment'
    import Vbdatapicker from '@/components/partials/vbdatapickerrci'
    export default {
        name:'listado',
        mixins : [customMixin],
        components:{
            Loading, vtable, Vbdatapicker
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 100,
                pageOptions: [ 100, 200],
                sortBy: '',
                sortDesc: true,
                limit:500,
                valor:'',
                filterOn: [],
                totalRows: 1,
                campos:['Orden','Fecha'],
                selected:'',
                fields:[
                    {key:'Id',label:'Id',sortable:true},
                    {key:'DiaHora',label:'Dia Hora',sortable:true},
                    {key:'Orden',label:'Orden',sortable:true},
                    {key:'Origen',label:'Maquina',sortable:true},
                    {key:'Contador',label:'Contador',sortable:true},
                    {key:'Operador',label:'Operario',sortable:false},
                    {key:'Estatus',label:'Estatus',sortable:false},
                    {key:'Producto',label:'Producto',sortable:true},
                ],
                sw: true,
                dia:null,
                dia2:null
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('filtroof',['datosphp']),
            ...mapState(['windowWidth']),//llamamos al estado.
            
        },
        
        methods:{
            ...mapActions({
                _fetchDia: 'filtroof/fetchDia',
                _fetchOf: 'filtroof/fetchOf'
            }),
            init(){
                let payload
                let fecha = new Date()
                fecha =  moment(fecha).format('YYYY-MM-DD')
                payload = {
                    'dia' : fecha
                }
                this._fetchDia(payload).then(() => {})
               
            },
            buscar(){
                if(this.selected === "Orden"){
                    let payload 
                    payload = {
                        'orden' : parseInt(this.valor)
                    }
                    this._fetchOf(payload).then(()=>{
                        if(this.datosphp.length > 0){
                            this.sw = false
                        }
                    })
                }else{
                    let payload
                    payload = {
                        'dia' :  this.dia.split("/").reverse().join("-"),
                        'dia2' :  this.dia2.split("/").reverse().join("-")
                    }
                    this._fetchDia(payload).then(() => {
                        if(this.datosphp.length > 0){
                            this.sw = false
                        }
                    })
                }
            },
            limpiar(){
                this.$router.go(0)
            },
        } 
    }
</script>

<style lang="scss" scoped>
.form-control{
	width:300px; 
	height:36px;
}
.buscar{
    height:36px;
}
.flex {
    display: flex
}
.contenedor-fechas{
    margin-top: -3%;
}
.fecha-inicial{
    margin-left:10px;
}
.fecha-final{
    margin-left:10px;
    margin-right: 10px;
}
@media (max-width: 767.98px) { 
    .flex{
        flex-direction:column;
    }
      .form-control{
        width:auto; 
	}
    .contenedor-fechas{
        margin-top: 0;
        margin-bottom: 2%;
    }
    .fecha-inicial{
        margin-left:10px;
    }
    .fecha-final{
        margin-left:10px;
        margin-right: 10px;
    }
}
</style>